<div class="table-container">
  <div class="table-grid" [style.grid-template-columns]="gridTemplateColumns()">
    <div class="table-header">
      @for (column of columns(); track column) {
        <div>{{ column.header() }}</div>
      }
    </div>
    @for (row of data(); track row) {
      <div tabindex="0"
           class="table-row"
           [class.selected]="selectedRow() === row"
           (dblclick)="onRowDoubleClicked(row)"
           (focus)="onRowFocus(row)"
           [attr.data-testid]="'table-row-' + row[testIdRowKey()]"
      >
        @for (column of columns(); track column) {
          <div class="table-cell">
            <ng-container *ngTemplateOutlet="column.template(); context: {$implicit: row}"></ng-container>
          </div>
        }
      </div>
    }
  </div>
</div>
